/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";

const InfographicsWidget = ({ blockID }) => {
    const [ state, setState ] = useState({
        isLoading: true,
        content: ""
    });

    useEffect(() => {
        if(state.isLoading && state.content === "") fetchContentBlock();
    }, []);

    const fetchContentBlock = () => {
        axios.get(`/api/cms/block/${blockID}`).then(({ data: { content }}) => {
            setState({
                isLoading: false,
                content: content
            });
        }).catch(error => {
            setState({
                ...state,
                isLoading: false
            });
            console.error(error);
        });
    };

    return (!state.isLoading && state.content !== "") &&<div className="pt-0 pb-2" dangerouslySetInnerHTML={{ __html: state.content }}></div>;
};

InfographicsWidget.propTypes = {
    blockID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default InfographicsWidget;